import Timepicker from './Timepicker'

export default Timepicker



// WEBPACK FOOTER //
// ./src/components/timepicker/index.js